// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"20671ce4","195":"0c3c4b9e","224":"eb837ee2","312":"9733c74d","390":"7abc89b1","487":"184f317f","509":"5f6eba6d","589":"7aff1b13","761":"ebab0a7e","824":"37de339c","965":"7b1e84f5"}[chunkId] + ".chunk.js";
};